// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';

import HistoryItemOutcomesSummary from './HistoryItemOutcomesSummary';
import selectHistoryItemOutcomesSummaryProps from './HistoryItemOutcomesSummary.selector';

type HistoryItemOutcomesSummaryContainerProps = {
  className?: string;
  isExpand?: boolean;
  onClickExpand?: () => void;
  outcomeNb?: number;
  outcomes: Array<{ outcomeId: number }>;
};

const HistoryItemOutcomesSummaryContainer = ({ outcomes, ...ownProps }: HistoryItemOutcomesSummaryContainerProps) => {
  const selectorProps = useMemo(() => ({ outcomes }), [outcomes]);

  const selectedProps = useSelector((state) => selectHistoryItemOutcomesSummaryProps(state, selectorProps));

  const enhancedProps = useMergeProps({ ownProps, selectedProps });

  return <HistoryItemOutcomesSummary {...enhancedProps} />;
};

export default HistoryItemOutcomesSummaryContainer;
